import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService {

  constructor(public http:HttpClient) { }

  getFundingSource(){
    return this.http.post(environment.api_link+'/api/auth/fundingSources',{})
  }
}
